import { ReactNode } from 'react';

import { WORLD } from 'global/emejis';
import { InquisitiveEmeji } from 'global/graphql/scalars.type';
import Emoji from 'approot/shared/emoji/emoji';
import { BoldStyled } from 'approot/shared/styles/typography.style';
import * as Styled from './classroom-student-identifier.style';
import { EmojiSizes } from 'approot/shared/emoji/emoji.constants';
import { useActivityBuilderPresentContext } from '../present/activity-builder-present.context';

type Props = {
  name: string;
  emoji: InquisitiveEmeji | null;
  size?: EmojiSizes;
  secondaryText?: ReactNode;
};

const ClassroomStudentIdentifier = ({
  name,
  emoji,
  size = 40,
  secondaryText,
}: Props) => (
  <Styled.ClassroomStudentIdentifier>
    <Styled.ClassroomStudentIdentifierEmoji>
      <Emoji id={emoji || WORLD} size={size} />
    </Styled.ClassroomStudentIdentifierEmoji>
    <Styled.ClassroomStudentIdentifierInner>
      <BoldStyled marginBottom={0}>{name}</BoldStyled>
      {secondaryText && (
        <Styled.ClassroomStudentIdentifierSecondaryContent>
          {secondaryText}
        </Styled.ClassroomStudentIdentifierSecondaryContent>
      )}
    </Styled.ClassroomStudentIdentifierInner>
  </Styled.ClassroomStudentIdentifier>
);

export default ClassroomStudentIdentifier;

export const ClassroomStudentIdentifierWithVisibility = (props: Props) => {
  const { isStudentNamesVisible } = useActivityBuilderPresentContext();

  return isStudentNamesVisible ? (
    <ClassroomStudentIdentifier {...props} />
  ) : null;
};
